export default "__VITE_ASSET__Cux1iZo9__"